import { createSlice } from '@reduxjs/toolkit';

const BankAccountSlice = createSlice({
  name: 'bankAccountSlice',
  initialState: {
    allBankAccounts: [],
  },
  reducers: {
    // get all bank accounts reducer
    getAllBankAccountsReducer: (state, action) => {
      state.allBankAccounts = action?.payload || [];
    },
  },
});

export default BankAccountSlice;
